import gql from 'graphql-tag';

export const guidedPracticeEnterSession = gql`
  mutation guidedPracticeEnterSession(
    $guidedPracticeRelationId: ID!
    $guidedPracticeRelationItemId: ID!
    $guidedPracticeSourceId: ID!
  ) {
    guidedPracticeEnterSession(
      guidedPracticeRelationId: $guidedPracticeRelationId
      guidedPracticeRelationItemId: $guidedPracticeRelationItemId
      guidedPracticeSourceId: $guidedPracticeSourceId
    ) {
      code
      success
      message
      session {
        id
        examSessionId
        startedAt
        status
        guidedPracticeId
        examPaperId
      }
    }
  }
`;

export const guidedPracticeSubmitExamPaperAnswer = gql`
  mutation guidedPracticeSubmitExamPaperAnswer(
    $examSessionId: ID!
    $examPaperItemId: ID!
    $answer: AnswerInput!
  ) {
    guidedPracticeSubmitExamPaperAnswer(
      examSessionId: $examSessionId
      examPaperItemId: $examPaperItemId
      answer: $answer
    ) {
      code
      success
      message
      answer {
        value
      }
    }
  }
`;

export const guidedPracticeGradeExamPaper = gql`
  mutation guidedPracticeGradeExamPaper($examSessionId: ID!) {
    guidedPracticeGradeExamPaper(examSessionId: $examSessionId) {
      code
      success
      message
    }
  }
`;
